module.exports = __webpack_public_path__ + "img/sup_deposit_jeten3.2951f258.jpg";